/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_UnavailableInputs */

const vi_carrier_form_unavailable = /** @type {(inputs: Carrier_Form_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không kết nối được Viettel Post, thử lại sau ít phút.`)
};

/**

* @param {Carrier_Form_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_unavailable = /** @type {((inputs?: Carrier_Form_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_unavailable(inputs)
});